/*
 * Сервисы классической разработки на главной: окружения из ArgoCD (Application
 * <сервис>-<namespace>: prod, stage, dev, feat-*), с пагинацией — сервисов много.
 */
import { AsyncState } from 'react-use/esm/useAsync';
import { routes, serviceEnvOf, serviceEnvRank } from '../../lib/viva';
import { ServingSummary } from '../argocd';
import { AsyncCell } from '../catalog/cells';
import { serviceColumns } from '../catalog/columns';
import { ServiceIcon } from '../icons';
import { ResourceCard } from './ResourceCard';
import { Resources, ServiceRow } from './useResources';

export const SERVICES_PAGE_SIZE = 5;

const columns = serviceColumns<ServiceRow>(row => (
  <AsyncCell state={row.apps} unavailable="ArgoCD недоступен">
    {apps => (
      <ServingSummary
        apps={apps ?? []}
        modelName={row.entity.metadata.name}
        envOf={serviceEnvOf}
        rank={serviceEnvRank}
        empty="не развёрнут"
      />
    )}
  </AsyncCell>
));

export const ServicesCard = ({
  resources,
}: {
  resources: AsyncState<Resources>;
}) => (
  <ResourceCard<ServiceRow>
    icon={<ServiceIcon />}
    title="Сервисы"
    to={routes.services}
    linkText="все сервисы"
    columns={columns}
    rows={resources.value?.services}
    loading={resources.loading}
    error={resources.error}
    errorTitle="Не удалось загрузить сервисы"
    emptyText="Сервисов пока нет — создайте первый из шаблона «Новый сервис»."
    createText="Новый сервис"
    createTo={routes.newService}
    pageSize={SERVICES_PAGE_SIZE}
  />
);
